import Reveal from "@/components/7fcc/Reveal";

// Shared section header: blue eyebrow label + display headline + muted support copy.
export default function SectionHeader({
  eyebrow,
  title,
  support,
  align = "center",
  delay = 0,
  testId,
}) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls}`}>
      {eyebrow && (
        <Reveal>
          <p
            className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-light"
            data-testid={testId ? `${testId}-eyebrow` : undefined}
          >
            <span className="h-px w-6 bg-brand/60" aria-hidden="true" />
            {eyebrow}
            {align === "center" && (
              <span className="h-px w-6 bg-brand/60" aria-hidden="true" />
            )}
          </p>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2
          className="mt-5 max-w-3xl font-display text-3xl font-semibold leading-[1.08] tracking-[-0.01em] text-fg md:text-5xl"
          data-testid={testId}
        >
          {title}
        </h2>
      </Reveal>
      {support && (
        <Reveal delay={0.16}>
          <p
            className={`mt-5 max-w-xl text-base leading-relaxed text-fg-muted md:text-lg ${align === "center" ? "mx-auto" : ""}`}
          >
            {support}
          </p>
        </Reveal>
      )}
    </div>
  );
}
